import { Injectable } from '@angular/core';

export type ActionCardButtonVariant =
  'default' | 'secondary' | 'outline' | 'ghost' | 'destructive' | 'link';

@Injectable()
export abstract class ActionCardStrategy {
  abstract imgSrc: string;
  abstract imgMode?: 'light' | 'dark' | 'swap' | undefined;
  abstract title: string;
  abstract description: string;
  abstract buttonLabel: string;
  abstract cardClassName: string | undefined;
  abstract severity: ActionCardButtonVariant;
  abstract uploadButtonImgSrc: string | undefined;
  abstract uploadButtonImgMode: 'light' | 'dark' | 'swap' | undefined;
}
